import React from 'react';
import { Typography } from '@material-ui/core';
import CenterSmUp from '€components/CenterSmUp';

type Props = {};

const SignUpInvalid: React.FC<Props> = props => (
    <CenterSmUp>
        <Typography>
            Your link has expired because it has not been used. Links expire within 24 hours and can
            only be used once.
        </Typography>
    </CenterSmUp>
);

export default SignUpInvalid;
